
import { connect } from 'react-redux';
import TypesMenu from '../components/types-menu';

const mapDispatchToProps = {};

const mapStateToProps = state => ({
  menuVisible: state.header.menuVisible,
});

export default connect(mapStateToProps, mapDispatchToProps)(TypesMenu);

